raymont.carousel = function() {

    new Swiper('.swiper-container', {
        direction: 'horizontal',
        loop: true,
        speed: 600,
        autoplay: 4000,
        pagination: '.swiper-pagination',
        paginationClickable: '.swiper-pagination',
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev'

    });

};